import { DefaultTopLevelGroup, Status } from "../../../../common/constants";
import { editQuickAlertsUrl } from "../../../../config";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../store";
import api from "../../../../api";

const initialState = {
  status: Status.IDLE,
  error: null,
  msg: null,
  editQuickAlertData: null,
};

interface IEditQuickAlertResponse {
  message: string;
}

interface IEditQuickAlertPayload {
  alertId: string;
  templateId?: string;
  alertTitle: string;
  alertMessage: string;
  severity: string;
  groups: any[];
  source: string;
  alertButtonName: string;
}

const EDIT_QUICK_ALERT: string = "editQuickAlert";

export const editQuickAlert = createAsyncThunk(
  EDIT_QUICK_ALERT,
  async (payload: IEditQuickAlertPayload, { rejectWithValue }) => {
    try {
      const { alertId, ...body } = payload;

      const response = await api.patch(
         `${editQuickAlertsUrl}?alertId=${encodeURIComponent(
            alertId
          )}&orgId=${encodeURIComponent(DefaultTopLevelGroup.ID)}`,
        body
      );
      const editQuickAlertResponse: IEditQuickAlertResponse = response.data;
      return editQuickAlertResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const editQuickAlertSlice = createSlice({
  name: EDIT_QUICK_ALERT,
  initialState,
  reducers: {
    setEditQuickAlertData: (state, action) => {
      if (action.payload) {
        state.editQuickAlertData = action.payload.alertData;
      } else {
        state.editQuickAlertData = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editQuickAlert.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(editQuickAlert.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(editQuickAlert.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || "Error occurred while updating";
      });
  },
});

export const { setEditQuickAlertData } = editQuickAlertSlice.actions;
export const selector = (state: RootState) => state.editQuickAlertsApi;
export const reducer = editQuickAlertSlice.reducer;
